const isNotFn = fn => typeof fn !== 'function';

// noinspection JSUnusedGlobalSymbols
export default isNotFn;
